export var isOnlyPragmaAvailable = function (merchantResponse) {
    return Boolean(merchantResponse.currentProvider.length === 1 &&
        merchantResponse.currentProvider[0] === 'pragma');
};
